import { FitpetErrorSubCodeEnum } from '@/apis/rest/generated/types'

export const isCouponError = (code: FitpetErrorSubCodeEnum) => {
  return code.includes('COUPON')
}
